import axiosInstance from "./axiosConfig";

class DashboardService {
  async getDashboardData(startDate, endDate) {
    try {
      const response = await axiosInstance.get(`dashboard/get-data`, {
        params: {
          startDate,
          endDate,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Dashboard veri çekme hatası:", error);
      console.error("Dashboard error response:", error.response);
      console.error("Dashboard error status:", error.response?.status);
      console.error("Dashboard error data:", error.response?.data);

      // Refresh token hatası durumunda özel mesaj
      if (error.message?.includes("No refresh token available")) {
        throw new Error("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.");
      }

      // 403 veya 401 hatası durumunda özel mesaj
      if (error.response?.status === 403 || error.response?.status === 401) {
        throw new Error("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.");
      }

      throw error;
    }
  }
}

export default new DashboardService();
